<template>
  <div class="container ptb-100">
    <div class="login-box bg-magnolia round-10 br-one">
      <div class="row">
        <div class="col-lg-5">
          <div class="login-img">
            <img src="../../assets/img/login-img.webp" alt="Image" />
          </div>
        </div>

        <div class="col-lg-7">
          <div class="login-form">
            <router-link to="/" class="logo mb-30 d-block">
              <img
                class="logo-light"
                src="../../assets/img/logo.webp"
                alt="Image"
              />
              <img
                class="logo-dark"
                src="../../assets/img/logo-white.webp"
                alt="Image"
              />
            </router-link>

            <h2 class="fs-34 mb-20">Login Now</h2>
            <form action="#">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group mb-20">
                    <input
                      id="email"
                      name="email2"
                      type="email"
                      class="bg-white br-four w-100 round-6"
                      required
                      placeholder="Your email"
                    />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group mb-20">
                    <input
                      id="pwd"
                      name="pwd"
                      type="password"
                      class="bg-white br-four w-100 round-6"
                      placeholder="Your password"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-12 mb-10">
                  <div class="checkbox style3">
                    <input type="checkbox" id="test_10" />
                    <label for="test_10">
                      I Agree with the
                      <router-link to="/terms-conditions">
                        Terms &amp; conditions
                      </router-link>
                    </label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <button class="btn style-one border-0 d-block w-100 mt-3">
                      Login Now
                    </button>
                  </div>
                </div>
                <div class="col-md-12 text-center">
                  <p class="mb-0 mt-2">
                    Don't have an account
                    <router-link to="/register" class="text_primary">
                      Click here to Register
                    </router-link>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginForm",
};
</script>